import { Component, Emit, Ref } from 'vue-property-decorator'
import VtGrid from '@/components/VtGrid/VtGrid.vue'
import GridDisplayOptions from '@/components/GridDisplayOptions.vue'
import BaseCrudClientSideComponent from '@/shared/resources/base-crud-client-side.component'
import { PatientSearchResponse } from '@/api/services/patient/patient/patient.dto'
import { BaseCrud } from '@/shared/models/cruds.models'
import { BModal } from 'bootstrap-vue'
import {
    initialPatientSelectionModalState,
    PatientSelectionModalState
} from '@/modules/billing-module/components/modal/patient/selection/billing-modal-patient-selection.model'
import { GridReadyEvent } from '@ag-grid-enterprise/all-modules'

@Component({
    components: {
        VtGrid,
        GridDisplayOptions
    }
})
export default class BillingModalPatientSelection extends BaseCrudClientSideComponent<PatientSearchResponse> implements BaseCrud {
    @Ref() readonly patientSelectionModal!: BModal

    @Emit()
    patientsSelected(patients: PatientSearchResponse[]) {
        return patients
    }

    state: PatientSelectionModalState
    constructor() {
        super()
        this.state = initialPatientSelectionModalState()
    }

    get disabledApplyButton(): boolean {
        return !this.state.selectedRows.length
    }

    onGridReady(event: GridReadyEvent): void {
        this.state.gridApi = event.api
        this.state.columnApi = event.columnApi
    }

    show(patients: PatientSearchResponse[]): void {
        this.state.rowData = patients
        this.patientSelectionModal.show()
    }
    hide(): void {
        this.patientSelectionModal.hide()
    }

    apply(): void {
        this.patientsSelected(this.state.selectedRows)
    }
}
